import _extends from '@babel/runtime/helpers/esm/extends';
import * as React from 'react';

var Valid = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1 6.002l4.6 4.6a.093.093 0 00.133 0L15 1.335",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  }));
});
Valid.displayName = 'Valid';

export { Valid, Valid as default };
